module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "businessTemplateManage"
  }, [_c('el-breadcrumb', {
    staticClass: "bread-nav",
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("首页")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("商业专题")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("组件管理")])], 1), _vm._v(" "), _c('el-button-group', {
    staticClass: "add-template-btn"
  }, [_c('el-button', {
    staticClass: "add-template",
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.addTemplate
    }
  }, [_vm._v("+添加组件")])], 1), _vm._v(" "), _c('el-table', {
    staticClass: "business-template-list-table",
    attrs: {
      "data": _vm.templateList,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "组件ID",
      "align": "center"
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.newsTypeId))])]
      }]
    ])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "组件名称",
      "align": "center"
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.newsTypeName))])]
      }]
    ])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "info"
          },
          on: {
            "click": function($event) {}
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              _vm.deleteTemplate(scope.row.newsTypeId)
            }
          }
        }, [_vm._v("删除")])]
      }]
    ])
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "添加组件"
    },
    on: {
      "close": _vm.closeAddTemplateDialog
    },
    model: {
      value: (_vm.config.addTemlateDialog.visible),
      callback: function($$v) {
        _vm.config.addTemlateDialog.visible = $$v
      },
      expression: "config.addTemlateDialog.visible"
    }
  }, [_c('el-form', {
    ref: "addTemplateForm",
    attrs: {
      "model": _vm.addTemplateForm,
      "rules": _vm.validateRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "名称",
      "prop": "newsTypeName"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addTemplateForm.newsTypeName),
      callback: function($$v) {
        _vm.addTemplateForm.newsTypeName = $$v
      },
      expression: "addTemplateForm.newsTypeName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "描述",
      "prop": "newsTypeContent"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addTemplateForm.newsTypeContent),
      callback: function($$v) {
        _vm.addTemplateForm.newsTypeContent = $$v
      },
      expression: "addTemplateForm.newsTypeContent"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.config.addTemlateDialog.visible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submitTemplate('addTemplateForm')
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-4ef6b1b0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/business/Template.vue
// module id = 764
// module chunks = 1